import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core';
import AclListContainer from 'components/AclList/AclListContainer';

const propTypes = {
  acls: PropTypes.instanceOf(Array),
  service: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
};

const defaultProps = {
  acls: [],
};

export function UnstyledAclTab({ acls, service, id, classes }) {
  return (
    <div className={classes.aclContainer}>
      <AclListContainer acls={acls} instanceService={service} instanceId={id} />
    </div>
  );
}

UnstyledAclTab.propTypes = propTypes;
UnstyledAclTab.defaultProps = defaultProps;

const styles = () => ({
  aclContainer: {
    padding: '20px 8px',
  },
});

export default withStyles(styles)(UnstyledAclTab);
